import { render } from "./StatBar.vue?vue&type=template&id=fc8947f8&scoped=true"
import script from "./StatBar.vue?vue&type=script&lang=js"
export * from "./StatBar.vue?vue&type=script&lang=js"

import "./StatBar.vue?vue&type=style&index=0&id=fc8947f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8947f8"]])

export default __exports__